import * as Material from "@mui/material";

export default function GroupLoadingSkeleton() {
    return (
        <>
            <div className="group-header">
                <div className="group-header__banner-wrap">
                    <Material.Skeleton
                        variant="rectangular"
                        width={64}
                        height={64}
                        sx={{ borderRadius: "var(--gap-2)" }}
                    />
                </div>
                <div className="group-header__info" style={{ flex: 1 }}>
                    <Material.Skeleton width="40%" height={28} />
                    <Material.Skeleton width="25%" height={18} />
                </div>
            </div>
            <div className="group-meta-section">
                <Material.Skeleton width="90%" height={18} />
                <Material.Skeleton width="80%" height={18} />
                <Material.Skeleton width="60%" height={18} />
            </div>
        </>
    );
}
